export const CLOUD_TITLE = 'Yandex.Cloud';

export const KeyCodes = {
    ARROW_LEFT: 37,
    ARROW_TOP: 38,
    ARROW_RIGHT: 39,
    ARROW_BOTTOM: 40,
    ENTER: 13,
    SPACE: 32,
    ESC: 27,
};

export const PAGE_TRANSITION_TIME = 300;

export const HEADER_HEIGHT = 64;

export const NON_ADAPTIVE_PAGE_REGEXP = [
    /^\/blog/,
    /^\/events/,
    /^\/features/,
    /^\/community/,
    /^\/partners$/,
    /^\/search/,
];

export const BREAKPOINTS = {
    xs: 0,
    sm: 577,
    md: 769,
    lg: 1081,
    xl: 1185,
};
